import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress benign "ResizeObserver loop completed/limit exceeded" — emitted by
// Radix UI / shadcn dropdowns and incorrectly elevated to a runtime error
// overlay by CRA's react-error-overlay.
const isResizeObserverError = (msg) =>
  typeof msg === "string" &&
  (msg.includes("ResizeObserver loop completed") || msg.includes("ResizeObserver loop limit exceeded"));

window.addEventListener("error", (e) => {
  if (isResizeObserverError(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
}, true);

window.addEventListener("unhandledrejection", (e) => {
  const msg = e?.reason?.message || e?.reason;
  if (isResizeObserverError(typeof msg === "string" ? msg : "")) {
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
